import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LaneSheetHeatStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const LaneSheetHeatContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LaneSheetHeatStateContext.Provider value={stateHook}>
      {children}
    </LaneSheetHeatStateContext.Provider>
  );
};

export default LaneSheetHeatContextProvider;